/* NEWSLETTER */
$('body').on('click', '#mc-embedded-subscribe', function() {
  if ($('#agree-newsletter').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

$('body').on('click', '#mc-embedded-subscribe-footer', function() {
  if ($('#agree-newsletter-footer').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

$('body').on('click', '#newsletter-button', function() {
  if ($('#agree-newsletter').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

$('body').on('click', '#newsletter-footer-button', function() {
  if ($('#agree-newsletter-footer').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

/* REGISTER */
$('body').on('click', '#create-customer .btn', function() {
  if ($('#agree-newsletter-register').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

/* BLOG */
// S'ha comentat un codi a l'arxiu theme.js a la linia 5409 perquè pugui funcionar el següent codi custom.
$(document).ready(function() {
  $('.menu').hide();
  $('.link-dropdown__link').click(function(){
    $(this).next('.menu').slideDown(1000).siblings('.menu').slideUp(1000);
  });
});

/* PRODUCT */
$(document).ready(function() {
  $('.template-product').on('variantChanged', function (evt, variant) {
    if (variant) {     
      // $('.mas_bb').html('');
      // if( variant.inventory_quantity > 0 ){
      //   $('.mas_bb').html('<p class="mas_bb_disp-stock">' + theme.strings.products_labels_in_stock + '</p>');
      //   $('button[type="submit"]').removeAttr('disabled');
      //   $('button[type="submit"]').html(theme.strings.products_product_add_to_cart);
      // } else {
      //   if (variant.inventory_policy == 'continue') {
      //     $('.mas_bb').load(location.href + ' .mas_bb', function(){
      //       var className = $('.mas_bb p').attr("class");
      //       if ( className == "mas_bb_disp-outstock" ) {
      //         $('button[type="submit"]').attr('disabled', 'disabled');
      //         $('button[type="submit"]').html(theme.strings.products_variant_no_stock); 
      //       } else {
      //         $('button[type="submit"]').removeAttr('disabled');
      //         $('button[type="submit"]').html(theme.strings.products_product_add_to_cart);
      //       }
      //       return false;
      //     });
      //   } else {
      //     $('.mas_bb').html('<p class="mas_bb_disp-outstock">' + theme.strings.products_labels_out_of_stock + '</p>');
      //     $('button[type="submit"]').attr('disabled', 'disabled');
      //     $('button[type="submit"]').html(theme.strings.products_variant_no_stock);
      //   }
      // }

      fetch(`${window.location.href}?variant=${variant.id}`)
      .then(response => response.text())
      .then(data => {
        const html = new DOMParser().parseFromString(data, 'text/html');
        const buyButtons = html.querySelectorAll('.buy-buttons-row');
        $('.buy-buttons-row').html(buyButtons);
      })
      .catch(error => {
        console.error('Error:', error);
      });
    } else {
      $('.mas_bb').html('');
    }
    return false;
  });
});